var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"event_details_list"},[_vm._l((this._props.event_details),function(value,propertyName){return [_c('li',{key:propertyName},[_vm._v(_vm._s(_vm._f("dashToSpace")(propertyName))+": "+_vm._s(value))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }